/*
 * Rennsieger — DRL product page.
 *
 * A trimmed fork of the headlight product JS. Colour, kit and facelift are
 * separate PRODUCTS, so those controls are plain links rendered in Liquid and need
 * no script here. This handles only the real in-page variants (market spec, laser),
 * the gallery, the accordions, the buy-oriented sticky bar and the VIN modal.
 * No dependencies; no-ops when its markup is absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('.rsg-dp');
  if (!root) return;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }

  /* ---------------- variant picker (spec / laser) ---------------- */
  function initVariants() {
    var form = root.querySelector('#rsg-dp-form');
    var vEl = root.querySelector('[data-rsg-hp-variants]');
    var oEl = root.querySelector('[data-rsg-hp-options]');
    if (!form || !vEl || !oEl) return;

    var variants = JSON.parse(vEl.textContent);
    var optionNames = JSON.parse(oEl.textContent);
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-rsg-opt-index]'));

    var idInput = form.querySelector('[data-rsg-hp-id]');
    // Two price spots on DRL pages (subtle top on mobile + above the ATC); keep both in sync.
    var priceEls = root.querySelectorAll('[data-rsg-hp-price]');
    var wasEl = root.querySelector('[data-rsg-hp-was]');
    var atc = root.querySelector('[data-rsg-hp-atc]');
    var atcLabel = root.querySelector('[data-rsg-hp-atc-label]');
    var atcPrice = root.querySelector('[data-rsg-hp-atc-price]');
    var stickyPrice = root.querySelector('[data-rsg-sticky-price]');

    // One selected value per option, seeded from the .is-sel buttons. Options with
    // no button row (a single-variant product) fall back to the variant's own value.
    var selected = optionNames.map(function (_, i) {
      var r = form.querySelector('[data-rsg-opt-index="' + i + '"]');
      if (r) {
        var sel = r.querySelector('.is-sel') || r.querySelector('[data-value]');
        return sel ? sel.getAttribute('data-value') : '';
      }
      return variants[0] ? variants[0]['option' + (i + 1)] : '';
    });

    function findVariant(values) {
      for (var k = 0; k < variants.length; k++) {
        var match = true;
        for (var i = 0; i < values.length; i++) {
          if (variants[k]['option' + (i + 1)] !== values[i]) { match = false; break; }
        }
        if (match) return variants[k];
      }
      return null;
    }

    function render() {
      var current = findVariant(selected);

      rows.forEach(function (row, i) {
        row.querySelectorAll('[data-rsg-opt-btn]').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var trial = selected.slice();
          trial[i] = val;
          var vr = findVariant(trial);
          btn.classList.toggle('is-soldout', !(vr && vr.available));
          btn.classList.toggle('is-sel', selected[i] === val);
        });
      });

      if (!current) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = current.id;
      priceEls.forEach(function (el) { el.textContent = money(current.price); });
      if (atcPrice) atcPrice.textContent = money(current.price);
      if (atc) atc.disabled = !current.available;
      if (atcLabel) atcLabel.textContent = current.available ? 'Add to cart' : 'Sold out';

      if (wasEl) {
        if (current.compare_at_price && current.compare_at_price > current.price) {
          wasEl.textContent = money(current.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (stickyPrice) stickyPrice.textContent = money(current.price);
    }

    rows.forEach(function (row, i) {
      row.querySelectorAll('[data-rsg-opt-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[i] = btn.getAttribute('data-value');
          render();
        });
      });
    });

    render();
  }

  /* ---------------- gallery ---------------- */
  function initGallery() {
    var main = root.querySelector('[data-rsg-gal-main]');
    var thumbs = root.querySelector('[data-rsg-gal-thumbs]');
    if (!main) return;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
    function show(i) {
      imgs.forEach(function (m) { m.classList.toggle('is-on', +m.getAttribute('data-i') === i); });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-on', +b.getAttribute('data-i') === i);
      });
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { show(+b.getAttribute('data-i')); });
    });
  }

  /* ---------------- accordions ---------------- */
  function initAcc() {
    root.querySelectorAll('[data-rsg-acc] .rsg-acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var a = q.nextElementSibling;
        var open = q.classList.contains('is-open');
        q.classList.toggle('is-open', !open);
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  /* ---------------- sticky buy bar ---------------- */
  function initSticky() {
    var bar = root.querySelector('[data-rsg-sticky]');
    var buy = root.querySelector('[data-rsg-hp-buy]');
    if (!bar || !buy) return;
    var btn = bar.querySelector('[data-rsg-sticky-btn]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('is-shown', !en[0].isIntersecting);
      }, { threshold: 0 }).observe(buy);
    }
    if (btn) btn.addEventListener('click', function () {
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------------- VIN check modal ----------------
   * Submits through Shopify's contact form so a VIN lands in the store inbox as an
   * ordinary inquiry. AJAX so the modal stays put and shows its own success state.
   */
  function initVin() {
    var modal = root.querySelector('[data-rsg-vin]');
    if (!modal) return;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var input = modal.querySelector('[data-rsg-vin-input]');
    var emailEl = modal.querySelector('[data-rsg-vin-email]');
    var form = modal.querySelector('#rsg-vin-contact');
    var wrap = modal.querySelector('[data-rsg-vin-form-wrap]');
    var success = modal.querySelector('[data-rsg-vin-success]');
    var submit = modal.querySelector('[data-rsg-vin-submit]');
    var errEl = modal.querySelector('[data-rsg-vin-err]');
    var lastFocus = null;

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      if (wrap) wrap.hidden = false;
      if (success) success.hidden = true;
      if (errEl) errEl.textContent = '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (input) input.addEventListener('input', function () {
      input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    });

    root.querySelectorAll('[data-rsg-vin-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(b); });
    });
    modal.querySelectorAll('[data-rsg-vin-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('rsg-vin__scrim')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) errEl.textContent = '';
      var email = emailEl ? (emailEl.value || '').trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        if (errEl) errEl.textContent = 'Please enter a valid email so we can send your result.';
        if (emailEl) emailEl.focus();
        return;
      }
      var vin = (input.value || '').trim();
      if (vin.length < 11) {
        if (errEl) errEl.textContent = "That doesn't look like a full VIN. It should be 17 characters.";
        input.focus();
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Sending…';
      fetch(form.getAttribute('action') || window.location.pathname, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        if (wrap) wrap.hidden = true;
        if (success) success.hidden = false;
        setTimeout(close, 2400);
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = 'Check my fit →';
        if (errEl) errEl.textContent = 'Could not send just now. Please try again, or DM us.';
      });
    });
  }

  function boot() {
    initVariants();
    initGallery();
    initAcc();
    initSticky();
    initVin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
